import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, ButtonBase, MenuItem, Popover, Typography } from '@material-ui/core';
import moment from 'moment';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { NotiIcon, TimeIcon, MoreIcon, DeleteIcon, ShareIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import { notifyP } from '../../bsApp';
import DiaLog from '../../../EHandover/components/Dropdown/dialog';
import FileCom from '../../../../components/FileCom';
import ForwardPopup from '../../../../components/ForwardPopup';
import { initForwardRole } from '../../../EHandover/components/Dropdown';
import useTags from '../../../../utils/useTags';
import { classNames, getUUID, onKeyUpEnterOrSpace, escapeHtmlKeepUrls } from '../../../../utils';
import { equipmentAPI } from '../../../../apis';
import rou from '../../../../router';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1.625rem 1.875rem 2.75rem 1.875rem',
    width: '100%',
    backgroundColor: theme.palette.font.white,
  },
  head: {
    display: 'flex',
    fontSize: '1.125rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: '600',
    alignItems: 'center',
    marginBottom: '1rem',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '1.125rem',
    fontWeight: '600',
    color: '#2e4469',
    fontFamily: 'NotoSans-Medium',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  notiIconBg: {
    width: '1.875rem',
    height: '1.875rem',
    borderRadius: '50%',
    backgroundColor: '#ffc95c',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '0.938rem',
    flexShrink: 0,
  },
  notiIcon: {
    fontSize: '1rem',
    color: theme.palette.font.white,
  },
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    whiteSpace: 'pre-wrap',
  },
  foot: {
    margin: '0.5rem 0 0',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  left: {
    display: 'flex',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
    color: theme.palette.font.sub,
    fontWeight: '500',
    flexWrap: 'wrap',
  },
  timeIconBg: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '0.625rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  timeIcon: {
    fontSize: '1.25rem',
    color: theme.palette.font.sub,
  },
  right: {
    display: 'flex',
    color: theme.palette.primary.main,
    flexWrap: 'nowrap',
  },
  showText: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
    fontWeight: 'bold',
  },
  dropIconBd: {
    marginLeft: '0.188rem',
    width: '1.5rem',
    height: '1.375rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropIcon: {
    fontSize: '0.875rem',
  },
  pushType: {
    width: '6.25rem',
    height: '1.375rem',
    borderRadius: '0.312rem',
    fontSize: '0.875rem',
    fontWeight: '500',
    textAlign: 'center',
    fontFamily: 'NotoSans-Medium',
    marginLeft: '1.875rem',
    flexShrink: 0,
  },
  btn: {
    borderRadius: '0',
    width: '1.5rem',
    height: '1.5rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  moreIcon: {
    fontSize: '1.125rem',
    color: theme.palette.font.sub,
  },
  delete: {
    width: '9.938rem',
    height: '3.81rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    padding: '1.188rem 0 1.188rem 0.938rem',
  },
  icon: {
    fontSize: '1.25rem',
    marginRight: '1.063rem',
    color: '#525e6c',
  },
  tag: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    letterSpacing: '0.0218rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    paddingRight: '1rem',
    display: 'flex',
    alignItems: 'center',
  },
  tagItem: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
    textAlign: 'center',
    letterSpacing: '0.013rem',
    color: theme.palette.font.white,
    fontWeight: '600',
    margin: '0.5rem 0.625rem 0.5rem 0',
    backgroundColor: '#979bff',
    height: '1.536rem',
    display: 'flex',
    alignItems: 'center',
    padding: '0 0.5rem',
    borderRadius: '0.25rem',
  },
  tableBox: {
    width: '46rem',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '1rem',
  },
  tableTitle: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e6e7e8',
    color: '#c0c6cb',
  },
  tableItem: {
    width: '20%',
    padding: '0.5rem 0 0.5rem 0',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    fontFamily: 'NotoSans-Bold',
  },
  tableContent: {},
  tableList: {
    display: 'flex',
    color: '#2e4469',
    alignItems: 'center',
    borderBottom: '1px solid #e6e7e8',
  },
  textDecoration: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: '#2e4469',
  },
}));

const ShowMore = ({
  anchorEl,
  handleOpenDropDown,
  handleCloseDropDown,
  handleDialogOpen,
  dialog,
  setDialog,
  notificationId,
  roomType,
  getList,
  id,
}) => {
  const classes = useStyles();
  const roleMap = useSelector((state) => state.roleMap);
  const forwardRole = initForwardRole(roomType, roleMap);

  return forwardRole ? (
    <>
      <ButtonBase className={classes.btn} onClick={handleOpenDropDown} id={`${id}-more`}>
        <MoreIcon className={classes.moreIcon} />
      </ButtonBase>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        id="Notification-Popover-aai"
        onClose={handleCloseDropDown}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem
          className={classes.delete}
          onClick={handleDialogOpen}
          id="Notification-ShowMore-MenuItem-aaj"
          style={{ borderTop: 'solid 1px #e4e7eb' }}
        >
          <ShareIcon className={classes.icon} />
          {i18n.t('EHANDOVER_NOTE_FORWARD')}
        </MenuItem>
      </Popover>
      <ForwardPopup open={dialog} setOpen={setDialog} notificationId={notificationId} handleSearch={getList} />
    </>
  ) : null;
};

export default function Notify({ allData, type, deleteNotificationAPI, getList, id }) {
  const classes = useStyles();
  const history = useHistory();
  const isScheduled = type === notifyP.scheduled;
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialog, setDialog] = useState(false);
  const tagsList = useTags(allData.roomType, allData.tagNames, true);
  const [notificationDesc, setNotificationDesc] = useState();
  const [loanRequestNotify, setLoanRequestNotify] = useState();
  const [longLoanRequestNotify, setLongLoanRequestNotify] = useState();
  const handleOpenDropDown = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropDown = () => {
    setAnchorEl(null);
  };

  const handleDialogOpen = () => {
    setDialog(true);
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setDialog(false);
  };
  const isJSON = (str) => {
    if (typeof str === 'string') {
      try {
        return JSON.parse(str);
      } catch (error) {
        return str;
      }
    }
    return str;
  };
  // Category：LOAN_REQUEST  ID能点，NOTIFICATION  按原来的显示，LONG_LOAN_REQUEST 显示表格
  const checkCategory = () => {
    const notificationDescObj = isJSON(allData?.notificationDesc);
    if (allData?.category === 'LOAN_REQUEST') {
      setLoanRequestNotify(notificationDescObj);
    } else if (allData?.category === 'LONG_LOAN_REQUEST') {
      setLongLoanRequestNotify(notificationDescObj);
    } else {
      setNotificationDesc(notificationDescObj);
    }
  };
  // to={rou.equipmentRou.path} 跳转到equipment page
  const getLoanRequestDetail = async (requestId) => {
    try {
      const { result } = await equipmentAPI.getLoanRequestDetail({ loanId: requestId });
      history.push({ pathname: rou.equipmentRou.path, query: { requestID: result[0].loanId, status: '' } });
    } catch (error) {}
  };
  useEffect(() => {
    checkCategory();
  }, []);
  const getPushType = () => {
    const handleDialogConfirm = () => {
      deleteNotificationAPI(allData.notificationId);
    };
    return (
      <>
        <ButtonBase className={classes.btn} onClick={handleOpenDropDown} id={`${id}-more`}>
          <MoreIcon className={classes.moreIcon} />
        </ButtonBase>
        <Popover
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          id="Notification-Popover-aai"
          onClose={handleCloseDropDown}
          keepMounted
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <MenuItem
            className={classes.delete}
            onClick={handleDialogOpen}
            id="Notification-MenuItem-aaj"
            style={{ borderTop: 'solid 1px #e4e7eb' }}
          >
            <DeleteIcon className={classes.icon} />
            {i18n.t('NOTIFICATION_SCHEDULED_DELETE')}
          </MenuItem>
        </Popover>
        <DiaLog
          dialog={dialog}
          handleDialogClose={handleDialogClose}
          id="Notification-DiaLog-aak"
          handleConfirm={handleDialogConfirm}
          head={i18n.t('NOTIFICATION_DELETE_HEAD')}
          body={i18n.t('NOTIFICATION_DELETE_BODY')}
          cancel={i18n.t('EHANDOVER_NOTE_DELETE_CANCEL')}
          confirm={i18n.t('EHANDOVER_NOTE_DELETE_CONFIRM')}
        />
      </>
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.head}>
        <Box display="flex" alignItems="center">
          <div className={classes.notiIconBg}>
            <NotiIcon className={classes.notiIcon} />
          </div>
          <Typography className={classes.title}>{allData?.notificationTitle}</Typography>
        </Box>
        {isScheduled ? (
          getPushType()
        ) : (
          <ShowMore
            anchorEl={anchorEl}
            handleOpenDropDown={handleOpenDropDown}
            handleCloseDropDown={handleCloseDropDown}
            handleDialogOpen={handleDialogOpen}
            dialog={dialog}
            setDialog={setDialog}
            notificationId={allData.notificationId}
            roomType={allData.roomType}
            getList={getList}
            id={id}
          />
        )}
      </div>
      {notificationDesc && (
        <div
          className={classes.context}
          dangerouslySetInnerHTML={{
            __html: escapeHtmlKeepUrls(String(notificationDesc)),
          }}
        />
      )}
      {loanRequestNotify && (
        <div className={classes.content}>
          <div>{loanRequestNotify.content}</div>
          <div>
            Request ID:{' '}
            <span
              className={classes.textDecoration}
              onClick={() => {
                (async () => {
                  await getLoanRequestDetail(loanRequestNotify.requestId);
                })();
              }}
              tabIndex={0}
              onKeyUp={(e) =>
                onKeyUpEnterOrSpace(e, () => {
                  (async () => {
                    await getLoanRequestDetail(loanRequestNotify.requestId);
                  })();
                })
              }
            >
              {loanRequestNotify.requestId}
            </span>
          </div>
          <div>{loanRequestNotify.requesterWard && <>Requester Ward: {loanRequestNotify.requesterWard}</>}</div>
          <div>{loanRequestNotify.providerWard && <>Provider Ward: {loanRequestNotify.providerWard}</>}</div>
          <div>Equipment Category: {loanRequestNotify.equipmentCategory}</div>
        </div>
      )}
      {longLoanRequestNotify && (
        <>
          <div>{longLoanRequestNotify.content}</div>
          <div className={classes.tableBox}>
            <div className={classes.tableTitle}>
              <div className={classes.tableItem} style={{ width: '15%' }}>
                REQUEST ID
              </div>
              <div className={classes.tableItem} style={{ width: '30%' }}>
                EQUIPMENT CATEGORY
              </div>
              <div className={classes.tableItem} style={{ width: '30%' }}>
                LOAN DATE
              </div>
              <div className={classes.tableItem} style={{ width: '15%' }}>
                DURATION (DAYS)
              </div>
              <div className={classes.tableItem} style={{ width: '10%' }}>
                OVERDUE
              </div>
            </div>
            <div className={classes.tableContent}>
              {_.map(longLoanRequestNotify?.longLoanEquipment, (item, index) => {
                return (
                  <div className={classes.tableList} key={index}>
                    <div
                      className={classNames(classes.tableItem, classes.textDecoration)}
                      style={{ width: '15%' }}
                      onClick={() => {
                        (async () => {
                          await getLoanRequestDetail(item.loanId);
                        })();
                      }}
                      tabIndex={0}
                      onKeyUp={(e) =>
                        onKeyUpEnterOrSpace(e, () => {
                          (async () => {
                            await getLoanRequestDetail(item.loanId);
                          })();
                        })
                      }
                    >
                      {item.loanId}
                    </div>
                    <div className={classes.tableItem} style={{ width: '30%' }}>
                      {_.map(item?.categorys, (categorysItem, categorysIndex) => {
                        return (
                          <div key={categorysIndex}>
                            {categorysItem.categoryName} x{categorysItem.assetCount}
                          </div>
                        );
                      })}
                    </div>

                    <div className={classes.tableItem} style={{ width: '30%' }}>
                      {item.transferDatetime}
                    </div>
                    <div className={classes.tableItem} style={{ width: '15%' }}>
                      {item.loanReminderDuration}
                    </div>
                    <div className={classes.tableItem} style={{ width: '10%' }}>
                      {item.overdue}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}

      <FileCom imgData={allData.imageIds} fileData={allData.fileIds} type="notification" />
      {tagsList.length > 0 ? (
        <Box display="flex" alignItems="center" flexWrap="wrap" mt="1.937rem">
          <div className={classes.tag}>{i18n.t('EHANDOVER_NOTE_TAG')}</div>
          {tagsList.map((item, index) => (
            <div className={classes.tagItem} key={getUUID()}>
              {item}
            </div>
          ))}
        </Box>
      ) : (
        <div />
      )}
      <div className={classes.foot}>
        <div className={classes.left}>
          {!isScheduled ? (
            <Box display="flex" flexWrap="warp" style={{ width: '12rem' }}>
              <div className={classes.timeIconBg}>
                <TimeIcon className={classes.timeIcon} />
              </div>
              {allData?.pushDate && moment(allData.pushDate).format('YYYY-MM-DD HH:mm')}
            </Box>
          ) : (
            <Box display="flex" flexWrap="warp">
              <div className={classes.timeIconBg}>
                <TimeIcon className={classes.timeIcon} />
              </div>
              {i18n.t('NOTIFICATION_SCHEDULED_ON', { value: moment(allData.pushDate).format('YYYY-MM-DD HH:mm') })}
            </Box>
          )}

          <Box mr="3rem" whiteSpace="nowrap">
            {i18n.t('NOTIFICATION_PUBLISHED_BY', { value: allData?.notificationFrom ?? allData?.createdBy ?? '' })}
          </Box>

          <Box mr="3rem" whiteSpace="nowrap">
            {`${i18n.t('NOTIFICATION_GROUP')}: ${(allData?.sendTo ?? []).map((s) => s.desc).join(', ')}`}
          </Box>
        </div>
        <div />
      </div>
      <div className={classes.foot}>
        <div className={classes.left}>
          <Box whiteSpace="pre-wrap" style={{ wordBreak: 'break-word' }}>{`${i18n.t('NOTIFICATION_SEND_TO')} : ${
            allData?.wardNames?.filter((item) => item).join(', ') ?? ''
          }`}</Box>
        </div>
        <div />
      </div>
    </div>
  );
}
